<template>
<div class="d-md-none" v-if="$route.name!=='UserProjectEdit' && $route.name!=='UserProjectCreate'">
  <v-container class="white lighten-3 px-4 py-4 bottomnav" fluid style="position:fixed;bottom:0px;left:0px;right:0px;z-index:100" v-if="menu_buttons.length">
    <v-row justify="space-around" align="center">
      <div v-for="(button,i) in menu_buttons" :key="i">
        <v-badge overlap color="red" v-if="button.badge">
          <template v-slot:badge>{{button.badge}}</template>
          <v-btn icon :color="button.color" @click="button.click ? button.click() : null" :to="button.to ? button.to : null">
            <v-icon>{{button.icon}}</v-icon>
          </v-btn>
        </v-badge>
        <v-btn v-else icon :color="button.color" @click="button.click ? button.click() : null" :to="button.to ? button.to : null" :disabled="button.disabled">
          <div :class="button.rank ? `rank-star rank-${$store.state.account.account.rank}-star` : ``">
            <v-icon :large="button.large ? true : false">{{button.icon}}</v-icon>
          </div>
        </v-btn>
      </div>
    </v-row>
  </v-container>
</div>
</template>
<script>
export default {
  name: "",
  computed: {
    newsLetterBell() {
      if (this.newsletter_prompted) {
        return null;
      }
      if (localStorage.getItem('newsletter_prompted')) {
        return null
      }
      return 1
    },
    menu_buttons() {
      if (!this.$store.getters['account/isLoggedIn']) {
        return [{
          color: 'secondary',
          to: '/contests',
          icon: 'fa-gift'
        }, {
          color: 'secondary',
          click: this.goSearch,
          icon: 'fa-search'
        }, {
          color: 'green',
          icon: 'fa-fas fa-plus-circle',
          to: '/login',
          large: true
        }, {
          color: 'secondary',
          badge: this.newsLetterBell,
          icon: 'fa-bell',
          click: this.openNewsletter
        }, {
          color: 'secondary',
          icon: 'fa-user',
          to: '/login'
        }]
      }


      if (this.$store.getters['account/type'] === 'user') {
        return [{
          color: 'secondary',
          to: '/contests',
          icon: 'fa-gift'
        }, {
          color: 'secondary',
          to: '/user/progress',
          icon: 'fa-star',
          rank: true
        }, {
          color: 'green',
          icon: 'fa-fas fa-plus-circle',
          to: '/user/projects/create',
          large: true
        }, {
          color: 'secondary',
          badge: this.$store.getters['notifications/count'],
          icon: 'fa-bell',
          click: this.openNotifications
        }, {
          color: 'secondary',
          icon: 'fa-user',
          to: '/user/profile'
        }]
      }

      if (this.$store.getters['account/type'] === 'business') {
        return [{
          color: 'secondary',
          to: '/contests',
          icon: 'fa-gift'
        }, {
          color: 'secondary',
          click: this.goSearch,
          icon: 'fa-search'
        }, {
          color: 'green',
          icon: 'fa-fas fa-plus-circle',
          click: this.createContest,
          large: true
        }, {
          color: 'secondary',
          badge: this.$store.getters['notifications/count'],
          icon: 'fa-bell',
          click: this.openNotifications
        }, {
          color: 'secondary',
          icon: 'fa-user',
          to: '/business/profile'
        }]
      }

      return []

    }
  },
  data: () => ({
    newsletter_prompted: false,
  }),
  methods: {
    createContest() {
      this.$eventBus.$emit('create_contest')
    },
    openNotifications: function() {
      this.$eventBus.$emit('show_notifications')
    },
    openNewsletter: function() {
      localStorage.setItem('newsletter_prompted', new Date().getTime())
      this.newsletter_prompted = true
      this.$eventBus.$emit('show_newsletter')
    },
    saveProject: function() {
      this.$store.dispatch('project_edit/save')
    },
    submitProject: function() {
      this.$store.dispatch('project_edit/submit')
    },
    goSearch: function() {
      if (this.$route.name === 'PublicProjects') {
        this.$store.commit('projects/show_search');
        setTimeout(function() {
          this.$vuetify.goTo("#search", {
            duration: 500,
            offset: 50,
            easing: "easeInOutCubic",
          })
        }.bind(this), 100)

      } else {
        this.$router.push("/#search")
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.show-small {
    display: none;
}
.hide-small {
    display: block;
}
.bottomnav {
    -webkit-box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
@media screen and (max-width: 320px) {
    .hide-small {
        display: none;
    }
    .show-small {
        display: block;
    }
}
</style>
